/**
 * Authorization with implements the ACL check from Flow
 * @type {string}
 */

class Authorization {

    #allowedResources = {};

    read  = 'read';
    write = 'write';

    constructor()
    {
        let user = window.localStorage.getItem("auth_remember");
        user = JSON.parse(user);
        if (
            user
            && user.allowedResources
        ) {
            this.#allowedResources = user.allowedResources;
        }
    }

    setAllowedResources(allowedResources)
    {
        this.#allowedResources = allowedResources;
    }

    isAllowed(path, permission = 'read')
    {
        let resource = this.#allowedResources[path];
        if (typeof resource !== 'object') {
            return false;
        }

        return !!resource[permission];
    }
}

let authorization = new Authorization()

export default authorization;
